import { apiDelete, apiGet, apiPost, apiPut } from './api';

export const postTemplate = (template, onSuccess) => apiPost('/template', template, onSuccess);

export const getTemplates = (onSuccess) => apiGet('/template', onSuccess);

export const updateTemplate = (templateId, template, onSuccess) =>
    apiPut(`/template/${templateId}`, template, onSuccess);

export const deleteTemplate = (templateId, onSuccess, onError) =>
    apiDelete(`/template/${templateId}`, onSuccess, onError);

export const saveTemplate = (templateId, template, onSuccess) => templateId ?
    updateTemplate(templateId, template, onSuccess) :
    postTemplate(template, onSuccess);
